import { Link } from "react-router-dom";
import NewsCard from "@/components/base/NewsCard";
import { news } from "@/mocks/news";
import type { NewsArticle } from "@/types";

export default function LatestNews() {
  const latest: NewsArticle[] = [...news]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 5) as NewsArticle[];

  return (
    <section className="px-5 md:px-10 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] gap-8 lg:gap-12 items-start">
        <div className="lg:sticky lg:top-28">
          <span className="text-xs font-medium tracking-[0.2em] uppercase text-accent-600">
            News & Updates
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2 mb-4">
            明星动态
          </h2>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6">
            第一时间掌握佐山爱的最新资讯 —— 新片发布、活动现场、幕后专访与影展动态，
            带你走近作品之外的每一个瞬间。
          </p>
          <Link
            to="/news"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-newspaper-line" />
            浏览全部动态
          </Link>
        </div>

        <div className="flex flex-col gap-4">
          {latest.map((article) => (
            <NewsCard key={article.id} article={article} variant="row" />
          ))}
        </div>
      </div>
    </section>
  );
}